import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { NamedLink } from '../../components';

const SectionHeading = () => {
  return (
    <div>
      <div>
        <NamedLink name="ApplicationInboxPage" params={{ tab: 'applications' }}>
          &lt; <FormattedMessage id="ApplicationPanel.inboxLinkText" />
        </NamedLink>
      </div>
    </div>
  );
};

export default SectionHeading;
